// Backend API Base URL
// export const apiUrl = "http://localhost:8000";

export const apiUrl = "https://store.navneetlawstudio.com";

// In-Memory Shared Cache & Request De-duplication for allbooks
let cachedBooks = null;
let activeBooksPromise = null;
let lastFetchTimestamp = 0;
const CACHE_TTL_MS = 60 * 1000; // 60 seconds TTL

export const fetchSharedBooks = () => {
  const now = Date.now();

  // Return cached copy if fresh
  if (cachedBooks && now - lastFetchTimestamp < CACHE_TTL_MS) {
    return Promise.resolve(cachedBooks);
  }

  // If a request is already in-flight, return the same promise to prevent duplicate requests
  if (activeBooksPromise) {
    return activeBooksPromise;
  }

  activeBooksPromise = fetch(`${apiUrl}/public/allbooks`)
    .then((res) => {
      if (!res.ok) throw new Error("Failed to fetch books");
      return res.json();
    })
    .then((data) => {
      cachedBooks = Array.isArray(data) ? data : [];
      lastFetchTimestamp = Date.now();
      activeBooksPromise = null;
      return cachedBooks;
    })
    .catch((err) => {
      activeBooksPromise = null;
      if (cachedBooks) return cachedBooks;
      throw err;
    });

  return activeBooksPromise;
};
